import { TWO } from '@/constants';
import { isAdmin, isCoach, SurveyChoiceText } from '@/types';

import type { InsightsViewerRole } from '@/constants';
import type { User } from '@/types';

export const isValidEmail = (email: string) => {
  if (email) {
    return !/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/u.test(email);
  }
  return false;
};

export const getChoiceText = (total: number, current: number) => {
  if (!current) return SurveyChoiceText.NO_ONE;
  if (total === current) return SurveyChoiceText.EVERYONE;
  if (total / TWO <= current) return SurveyChoiceText.MOST;
  return SurveyChoiceText.SOME;
};

export const resolveInsightsViewerRole = (
  viewer: User,
  isSelfView = false,
): InsightsViewerRole => {
  if (isSelfView) {
    return 'member';
  }

  if (isAdmin(viewer)) {
    return 'admin';
  }

  if (isCoach(viewer)) {
    return 'coach';
  }

  return 'member';
};
